import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=47fdeed2&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=ts&"
export * from "./Error404.vue?vue&type=script&lang=ts&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=47fdeed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdeed2",
  null
  
)

export default component.exports